import { AriaMenuStatus } from "../../menu-event-adapter/enums/AriaMenuStatus";
import { ComboboxAriaModel } from "../../menu-event-adapter/types/ComboboxAriaModel";

export const initialComboBoxAriaModel: ComboboxAriaModel = {
    activeItemIndex: 0,
    isOpen: false,
    type: AriaMenuStatus.Closed,
    userInput: ""
} as const;
